import type { Language } from "@/lib/i18n/translations";
import { getSchemaType } from "./schemaTypes";
import { GUIDE_META } from "./structuredDataGuide";

type Meta = { title: string; description: string };
type L = Record<Language, Meta>;

const STATIC: Record<string, L> = {
  "/pricing": {
    en: { title: "Pricing – Schema Markup Generator Plans | SchemasGen", description: "Free plan with 3 analyses per day, then plans from €9/month and credit packs that never expire. Generate JSON-LD structured data at scale." },
    fr: { title: "Tarifs – Générateur de données structurées | SchemasGen", description: "Forfait gratuit avec 3 analyses par jour, puis forfaits dès 9 €/mois et packs de crédits sans expiration. Générez vos données structurées JSON-LD à grande échelle." },
    es: { title: "Precios – Generador de datos estructurados | SchemasGen", description: "Plan gratuito con 3 análisis al día, planes desde 9 €/mes y paquetes de créditos que no caducan. Genera datos estructurados JSON-LD a escala." },
  },
  "/docs": {
    en: { title: "API Documentation – JSON-LD Generator API | SchemasGen", description: "Generate structured data programmatically with the SchemasGen REST API and MCP server for AI assistants." },
    fr: { title: "Documentation API – API de génération JSON-LD | SchemasGen", description: "Générez des données structurées par programme avec l'API REST SchemasGen et le serveur MCP pour assistants IA." },
    es: { title: "Documentación API – API generadora de JSON-LD | SchemasGen", description: "Genera datos estructurados mediante la API REST de SchemasGen y el servidor MCP para asistentes de IA." },
  },
  "/contact": {
    en: { title: "Contact | SchemasGen", description: "Questions about SchemasGen or structured data? Get in touch with our team." },
    fr: { title: "Nous joindre | SchemasGen", description: "Une question sur SchemasGen ou les données structurées ? Contactez notre équipe." },
    es: { title: "Contacto | SchemasGen", description: "¿Preguntas sobre SchemasGen o los datos estructurados? Contacta con nuestro equipo." },
  },
};

/** Returns route-specific title/description, or null to fall back to the sitewide defaults. */
export function getPageMeta(basePath: string, lang: Language): Meta | null {
  if (STATIC[basePath]) return STATIC[basePath][lang];
  if (basePath === "/structured-data") {
    return { title: GUIDE_META.metaTitle[lang], description: GUIDE_META.metaDescription[lang] };
  }
  const m = basePath.match(/^\/structured-data\/([^/]+)$/);
  if (m) {
    const g = getSchemaType(m[1]);
    if (g) return { title: g.metaTitle[lang], description: g.metaDescription[lang] };
  }
  return null;
}
